module.exports = __webpack_public_path__ + "img/DoellkenProfilesBrandLogo.1768e530.svg";